import { http, createConfig } from "@wagmi/core";
import { bsc } from "@wagmi/core/chains";

/**
 * BSC 只读 transport：只走同源 /api/rpc.php
 *（后端 NodeReal 主用 + 公共 failover；浏览器不再直连 dataseed）
 */
export const wagmiConfig = createConfig({
  chains: [bsc],
  transports: {
    [bsc.id]: http("/api/rpc.php", {
      timeout: 18_000,
      retryCount: 2,
      retryDelay: 280,
    }),
  },
  multiInjectedProviderDiscovery: false,
});

export const BSC_ID = bsc.id;
